import { useEffect } from "react";
import { stores } from "../stores/rootStore";
import "./about.css";
import maker from "./img/maker2Ready.png";
import vk from "./img/VK.svg";
import whats from "./img/WhatsApp.svg";
import viber from "./img/Viber.svg";

export const About = () => {
  useEffect(() => {
    stores.helpUIStore.setTitle("о нас");
    stores.helpUIStore.setHistory(["about"]);
  }, []);
  return (
    <div className="about_wrapper">
      <div className="about_info_head"> Дарим радость уже 12 лет 🌼</div>

      <div className="about_info_head">Наши контакты:</div>
      <div className="about_info">
        <div className="about_item">
          <img src={maker} alt="Маркер" />
          <div>
            <div>ул. Мира 61 </div>
            <div>🕚 Круглосуточно</div>
            <div>📞+7(3953)380-388</div>
          </div>
        </div>
        <div className="about_item">
          <img src={maker} alt="Маркер" />
          <div>
            <div>ул. Советская 1</div>
            <div>🕚 9.00 - 21.00</div>
            <div>📞+7(3953)27-90-90</div>
          </div>
        </div>
        <div className="about_item">
          <img src={maker} alt="Маркер" />
          <div>
            <div>ул. Крупской 27</div>
            <div>🕚 9.00 - 21.00</div>
            <div>📞+7(3953)28-50-56</div>
          </div>
        </div>
        <div className="about_item">
          <img src={maker} alt="Маркер" />
          <div>
            <div>ул. Погодаева 16</div>
            <div>🕚 вс-чт 8.00 - 20.00</div>
            <div>🕚 пт, сб 8.00 - 22.00</div>
            <div>📞+7(3953)388-188</div>
          </div>
        </div>
        <div className="about_item">
          <img src={maker} alt="Маркер" />
          <div>
            <div>ТЦ Москва, Маршала Жукова 7 , 1 этаж</div>
            <div>🕚 10.00 - 20.00</div>
            <div>📞+7(3953)38-44-88</div>
          </div>
        </div>
      </div>
      <div className="about_contacts">
        <a
          href="https://vk.com/roza_luxury"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="about_contact_item">
            <img src={vk} alt="Вконтакте" />
            <span>Мы Вконтакте</span>
          </div>
        </a>
        <div className="about_contact_item">
          <img src={whats} alt="Whatsapp" />
          <img src={viber} alt="viber" />
          <span>+7 (964) 357-03-88</span>
        </div>
      </div>
    </div>
  );
};
